module.exports = __webpack_public_path__ + "static/media/locate.8f5ddaf4.svg";